import { ChevronLeft } from '../../components/ui/icons';

export function BackBar({ onBack, label, eyebrow }: { onBack: () => void; label: string; eyebrow: string }) {
  return (
    <div className="flex items-center justify-between gap-3 pt-2 md:pt-5">
      <button type="button" onClick={onBack} className="tap -ml-1 flex shrink-0 items-center gap-[2px] text-ink">
        <ChevronLeft width={22} height={22} strokeWidth={2.4} />
        <span className="text-[16px] font-semibold tracking-snug">{label}</span>
      </button>
      <div className="eyebrow min-w-0 flex-1 truncate text-right font-bold">{eyebrow}</div>
    </div>
  );
}
